module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "pixels.c9ce1e84.webp";